import FolderIcon from "@mui/icons-material/Folder";
import { Avatar, List, ListItem, ListItemAvatar, ListItemText, Paper } from "@mui/material";
import React from "react";
import { ListModel } from "../../Models/ListModel";
import IComponentProps from "../IComponentProps";

const ListComponent: React.FC<IComponentProps<ListModel>> = ({ component, context }) => {
  // Mocked data for demonstration
  const mockItems = [
    { id: 1, primary: "Item 1", secondary: "Description for item 1" },
    { id: 2, primary: "Item 2", secondary: "Description for item 2" },
    { id: 3, primary: "Item 3", secondary: "Description for item 3" },
    { id: 4, primary: "Item 4", secondary: "Description for item 4" },
    { id: 5, primary: "Item 5", secondary: "Description for item 5" },
  ];

  return (
    <Paper>
      <List>
        {mockItems.map((item) => (
          <ListItem key={item.id}>
            <ListItemAvatar>
              <Avatar>
                <FolderIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={item.primary} secondary={item.secondary} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default ListComponent;
